import { render, staticRenderFns } from "./LabeledFlexSection.vue?vue&type=template&id=503e8991&scoped=true"
import script from "./LabeledFlexSection.vue?vue&type=script&lang=js"
export * from "./LabeledFlexSection.vue?vue&type=script&lang=js"
import style0 from "./LabeledFlexSection.vue?vue&type=style&index=0&id=503e8991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e8991",
  null
  
)

export default component.exports